import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import $ from 'jquery';
import { BriefItem, ConditionItem, DataDetail, GameQueryReq, GameQueryResp, INSPLAN_MAP, ListItem, PrizeItem } from 'bff/models/game/gameQuery';
import { DrawStatus } from 'constants/enums/drawStatus.enum';
import gameService from 'bff/services/gameService';
import commonService from 'utils/commonService';
import BgImage from 'components/BgImage';
import SlotMachine from 'components/SlotMachine';
import DotPagination from 'components/DotPagination';
import SliderGame from 'components/SliderGame';
import { DrawResult, IProps, StatusItem } from './types';
import { GameDodrawResp } from 'bff/models/game/gameDodraw';
import Page from './Page';
import Slider from './Slider';

const statusList = [
  {
    index: 0,
    value: '',
    text: '全部',
    keyword: ''
  },
  {
    index: 1,
    value: 'available',
    text: '可抽獎活動',
    keyword: '可抽獎'
  },
  {
    index: 2,
    value: 'participated',
    text: '已參加過',
    keyword: '已參加過'
  },
  {
    index: 3,
    value: 'unavailable',
    text: '資格不符',
    keyword: '資格不符'
  },
  {
    index: 4,
    value: 'overdue',
    text: '活動逾期',
    keyword: '活動逾期'
  },
  {
    index: 5,
    value: 'canceled',
    text: '因故停止',
    keyword: '因故停止'
  }
];

// declare const $: any;
const PAGE_SIZE = 6;

// 前端測試(資料庫尚無資料的測試)
const listForTest = [
  {
    SN: 1,
    GAME_ID: '24032012345',
    TITLE: '抽獎活動測試資料標題最多64個字',
    IMAGE_NAME: '1920px-KB_Dvorak_Left.svg.png',
    START_DATE: '2024-01-20 00:00:00',
    END_DATE: '2034-03-20 00:00:00',
    DRAW_CNT: 1,
    DRAW_STATUS: 'D',
    STATUS_MSG: '可抽獎次數: 1次'
  },
  {
    SN: 2,
    GAME_ID: '24032012346',
    TITLE: '抽獎活動測試資料標題最多64個字',
    IMAGE_NAME: '1920px-KB_Dvorak_Left.svg.png',
    START_DATE: '2024-01-20 00:00:00',
    END_DATE: '2034-03-20 00:00:00',
    DRAW_CNT: 0,
    DRAW_STATUS: 'S',
    STATUS_MSG: '資格不符'
  },
  {
    SN: 3,
    GAME_ID: '24032012347',
    TITLE: '抽獎活動測試資料標題最多64個字',
    IMAGE_NAME: '1920px-KB_Dvorak_Left.svg.png',
    START_DATE: '2024-01-20 00:00:00',
    END_DATE: '2034-03-20 00:00:00',
    DRAW_CNT: 0,
    DRAW_STATUS: 'S',
    STATUS_MSG: '資格不符'
  },
  {
    SN: 4,
    GAME_ID: '24032012348',
    TITLE: '抽獎活動測試資料標題最多64個字',
    IMAGE_NAME: '1920px-KB_Dvorak_Left.svg.png',
    START_DATE: '2024-01-20 00:00:00',
    END_DATE: '2034-03-20 00:00:00',
    DRAW_CNT: 0,
    DRAW_STATUS: 'S',
    STATUS_MSG: '已參加過'
  },
  {
    SN: 5,
    GAME_ID: '24032012349',
    TITLE: '抽獎活動測試資料標題最多64個字',
    IMAGE_NAME: '1920px-KB_Dvorak_Left.svg.png',
    START_DATE: '2024-01-20 00:00:00',
    END_DATE: '2034-03-20 00:00:00',
    DRAW_CNT: 1,
    DRAW_STATUS: 'D',
    STATUS_MSG: '可抽獎次數: 1次'
  },
  {
    SN: 6,
    GAME_ID: '24032012350',
    TITLE: '抽獎活動測試資料標題最多64個字',
    IMAGE_NAME: '1920px-KB_Dvorak_Left.svg.png',
    START_DATE: '2024-01-20 00:00:00',
    END_DATE: '2034-03-20 00:00:00',
    DRAW_CNT: 1,
    DRAW_STATUS: 'D',
    STATUS_MSG: '可抽獎次數: 1次'
  },
  {
    SN: 7,
    GAME_ID: '24032012351',
    TITLE: '抽獎活動測試資料標題最多64個字',
    IMAGE_NAME: '1920px-KB_Dvorak_Left.svg.png',
    START_DATE: '2024-01-20 00:00:00',
    END_DATE: '2034-03-20 00:00:00',
    DRAW_CNT: 1,
    DRAW_STATUS: 'D',
    STATUS_MSG: '可抽獎次數: 1次'
  }
];

// 前端測試(資料庫尚無資料的測試)
const detailForTest = {
  SN: 1,
  GAME_ID: '25020600001',
  TITLE: '抽貓砂',
  SUBTITLE: '',
  GAME_DESC: '貓砂貓砂貓砂',
  IMAGE_NAME: '1920px-KB_Dvorak_Left.svg.png',
  START_DATE: '2025/02/06',
  END_DATE: '2025/02/28',
  MULTI_DRAW: 'Y',
  GAME_TYPE: 'SL',
  CODE_CLASS: '25020600001',
  STATUS: '1',
  BLN_TITLE: '未中獎',
  BLN_IMAGE: 'pets01-1-.jpg',
  BLN_DESC: '哭哭哭哭哭!',
  ONHOLD_MSG: '',
  GAME_BRIEF: [
    {
      SN: 518,
      CODE_CLASS: '25020600001',
      CODE_ID: '1',
      CODE_VALUE: '成功投保寵物險抽貓砂',
      NOTE: ''
    },
    {
      SN: 519,
      CODE_CLASS: '25020600001',
      CODE_ID: '2',
      CODE_VALUE: '成功投保寵物險抽貓砂',
      NOTE: ''
    },
    {
      SN: 520,
      CODE_CLASS: '25020600001',
      CODE_ID: '3',
      CODE_VALUE: '成功投保寵物險抽貓砂',
      NOTE: ''
    }
  ],
  PRIZE: [
    {
      SN: 2,
      GAME_ID: '25020600001',
      SHOW_ORDER: 1,
      ITEM_NAME: '頭獎',
      ITEM_IMAGE: '1920px-KB_Dvorak_Left.svg.png',
      ITEM_DESC: '貓砂3公斤5包',
      ITEM_QTY: 1,
      ITEM_PROB: 10,
      ITEM_QTY_TAKEN: 0,
      STATUS: '1',
      CREATE_ID: '7757',
      CREATE_TIME: '2025-02-06 10:26:43.000',
      UPDATE_ID: '7686',
      UPDATE_TIME: '2025-02-11 14:43:02.000'
    },
    {
      SN: 3,
      GAME_ID: '25020600001',
      SHOW_ORDER: 2,
      ITEM_NAME: '二獎',
      ITEM_IMAGE: 'pets01-phone.jpg',
      ITEM_DESC: '貓砂3公斤3包',
      ITEM_QTY: 7,
      ITEM_PROB: 20,
      ITEM_QTY_TAKEN: 3,
      STATUS: '1',
      CREATE_ID: '7757',
      CREATE_TIME: '2025-02-06 10:26:43.000',
      UPDATE_ID: '7686',
      UPDATE_TIME: '2025-02-11 14:43:02.000'
    },
    {
      SN: 4,
      GAME_ID: '25020600001',
      SHOW_ORDER: 3,
      ITEM_NAME: '三獎',
      ITEM_IMAGE: 'pets01-2.jpg',
      ITEM_DESC: '貓砂3公斤1包',
      ITEM_QTY: 18,
      ITEM_PROB: 30,
      ITEM_QTY_TAKEN: 2,
      STATUS: '1',
      CREATE_ID: '7757',
      CREATE_TIME: '2025-02-06 10:26:43.000',
      UPDATE_ID: '7686',
      UPDATE_TIME: '2025-02-11 14:43:02.000'
    },
    {
      SN: 5,
      GAME_ID: '25020600001',
      SHOW_ORDER: 4,
      ITEM_NAME: '四獎',
      ITEM_IMAGE: 'pets01-2.jpg',
      ITEM_DESC: '貓砂3公斤1包',
      ITEM_QTY: 18,
      ITEM_PROB: 30,
      ITEM_QTY_TAKEN: 6,
      STATUS: '1',
      CREATE_ID: '7757',
      CREATE_TIME: '2025-02-06 10:26:43.000',
      UPDATE_ID: '7686',
      UPDATE_TIME: '2025-02-11 14:43:02.000'
    }
  ],
  CONDITION: [
    {
      SN: 3,
      GAME_ID: '25020600001',
      COND_CLASS: 'REG',
      COND_CLASS_DCNT: 5,
      COND_CLASS_DESC: '於指定活動時間內註冊成為會員且勾選同意收到eDM，即可享有${' + 'n' + '}次抽獎機會。',
      REG: 'Y',
      REG_STIME: '2025-02-06 00:00:00',
      REG_ETIME: '2025-02-28 23:59:59',
      REG_NOTE: '於 2025/02/06 00:00 至 2025/02/28 23:59 內成功註冊且勾選同意收到eDM',
      INSPLAN: '',
      INSPLAN_ID: null,
      INSPLAN_NOTE: {},
      SOURCE: '',
      SOURCE_ID: '',
      SOURCE_NOTE: '',
      BC_TYPE: '',
      BC_TYPE_ID: '',
      BC_TYPE_NOTE: '',
      FEE: '',
      FEE_MIN: 0,
      FEE_MAX: 0,
      FEE_NOTE: '',
      POLICY_DELIVERY: '',
      POLICY_DELIVERY_ID: '',
      POLICY_DELIVERY_NOTE: '',
      CECODE: '',
      CECODE_ID: '',
      CECODE_CODE: '',
      CECODE_NOTE: '',
      PAY_BY: '',
      PAY_BY_ID: '',
      PAY_BY_NOTE: '',
      CREATE_ID: '7757',
      CREATE_TIME: '2025-02-06 10:26:43.000',
      UPDATE_ID: '7686',
      UPDATE_TIME: '2025-02-11 14:43:02.000'
    },
    {
      SN: 4,
      GAME_ID: '25020600001',
      COND_CLASS: 'INSURE',
      COND_CLASS_DCNT: 5,
      COND_CLASS_DESC: '於指定活動時間內完成投保，投保時滿足以下條件者，即可享有${' + 'n' + '}次抽獎機會。',
      REG: '',
      REG_STIME: null,
      REG_ETIME: null,
      REG_NOTE: '',
      INSPLAN: 'NA',
      INSPLAN_ID: 'I02-AP6,I03-AM5',
      INSPLAN_NOTE: { display: null, data: null, type: 'text', value: '不指定' },
      SOURCE: 'NA',
      SOURCE_ID: '',
      SOURCE_NOTE: '不指定',
      BC_TYPE: 'NA',
      BC_TYPE_ID: '',
      BC_TYPE_NOTE: '不指定',
      FEE: 'NA',
      FEE_MIN: 0,
      FEE_MAX: 0,
      FEE_NOTE: '不指定',
      POLICY_DELIVERY: 'NA',
      POLICY_DELIVERY_ID: '',
      POLICY_DELIVERY_NOTE: '不指定',
      CECODE: 'NA',
      CECODE_ID: '',
      CECODE_CODE: '',
      CECODE_NOTE: '不指定',
      PAY_BY: 'NA',
      PAY_BY_ID: '',
      PAY_BY_NOTE: '不指定',
      CREATE_ID: '7757',
      CREATE_TIME: '2025-02-06 10:26:43.000',
      UPDATE_ID: '7686',
      UPDATE_TIME: '2025-02-11 14:43:02.000'
    }
  ]
};

const Game: React.FC<IProps> = (props) => {
  const [activeStatus, setActiveStatus] = useState<StatusItem>(statusList[0]);
  const [listCollapsed, setListCollapsed] = useState<boolean>(false);
  const [descCollapsed, setDescCollapsed] = useState<boolean>(false);
  const [conditionCollapsed, setConditionCollapsed] = useState<boolean>(false);
  const [gameList, setGameList] = useState<ListItem[]>([]);
  const [pageIndex, setPageIndex] = useState<number>(0);
  const [gameItem, setGameItem] = useState<ListItem | null>(null);
  const [gameDetail, setGameDetail] = useState<DataDetail | null>(null);
  const [drawCount, setDrawCount] = useState<string>('');
  /** 紀錄當前活動的最後一次抽獎結果 */
  const [lastResult, setLastResult] = useState<DrawResult | null>(null);

  /**
   * @description 於頁面初始階段，取得抽獎活動列表
   */
  useEffect(() => {
    (async () => {
      const args: GameQueryReq = {
        QUERY_TYPE: 'list'
      };
      const response = await gameService.gameQuery(args);
      if (response && response.LIST) {
        setGameList(response.LIST);
      }
      // 前端測試(資料庫尚無資料的測試)
      // setGameList(listForTest);
      // setGameList([]); // 空資料
      commonService.scrollToTop();
    })();
  }, []);

  /**
   * @description 若活動狀態變更，則重置抽獎活動明細與抽獎結果
   */
  useEffect(() => {
    setLastResult(null);
    setGameItem(null);
    setGameDetail(null);
  }, [activeStatus]);

  /**
   * @description 處理活動狀態 onClick 執行的事件
   * @param value 活動狀態
   */
  const handleStatusClick = (currentStatus: StatusItem) => {
    if (currentStatus) setActiveStatus(currentStatus);
  };

  /**
   * @description 處理抽獎活動卡片 onClick 執行的事件
   * @param game 抽獎活動
   */
  const handleGameClick = async (game: ListItem) => {
    if (!game) return;
    // 查詢抽獎活動明細
    const args: GameQueryReq = {
      QUERY_TYPE: 'detail',
      GAME_ID: game.GAME_ID
    };
    const response: GameQueryResp | undefined = await gameService.gameQuery(args);
    if (response && response.DATA) {
      setLastResult(null);
      setGameItem(game);
      setGameDetail(response.DATA);
      setDrawCount(game.DRAW_CNT.toString());
      // handleListClick();
      setListCollapsed(prevState => !prevState);
      $('#gamelist').slideToggle();
      // 查詢成功後，重置「活動說明」與「活動資格」收合鈕
      setDescCollapsed(false);
    }
    // 前端測試(資料庫尚無資料的測試)
    // hadnleDetailTest(game);
  };

  /**
   * @description 測試取得明細
   * @param game 點擊列表之項目
   */
  const hadnleDetailTest = (game: ListItem) => {
    setLastResult(null);
    setGameItem(game);
    detailForTest.SN = game.SN;
    detailForTest.GAME_ID = game.GAME_ID;
    setGameDetail(detailForTest);
    setDrawCount(game.DRAW_CNT.toString());
    setListCollapsed(prevState => !prevState);
    $('#gamelist').slideToggle();
    setDescCollapsed(false);
  };

  /**
   * @description 處理符合抽獎資格之註冊條件
   */
  const renderRegCondition = () => {
    const cond: ConditionItem | undefined = gameDetail?.CONDITION.find(it => it.COND_CLASS === 'REG');
    if (!cond) return null;
    // 若無 ${n} 關鍵字，則使用整串文字
    const isMatched = cond.COND_CLASS_DESC.match(/\$\{n\}/);
    if (!isMatched) {
      return (
        <li>
          註冊：{cond.COND_CLASS_DESC}
        </li>
      );
    }
    // 替換次數標記為抽講次數，並改為紅字
    const snippets = cond.COND_CLASS_DESC.split(/\$\{n\}/);
    return (
      <li>
        註冊：{snippets[0]}<span className="emphsis">{cond.COND_CLASS_DCNT}</span>{snippets[1]}
      </li>
    );
  };

  /**
   * @description 呈現表格或文字
   * @param item 險種/方案
   */
  const renderInsPlans = (item: INSPLAN_MAP) => {
    if (!item) return (<li>險種/方案：</li>);
    if (item.type === 'text') {
      return (
        <li>險種/方案：{item.value}</li>
      );
    }
    if (item.display === 'table' && item.data) {
      const groups = Object.keys(item.data);
      return (
        <li>
          險種/方案
          <div className="insplan-table">
            {groups.map((key, index) => {
              // 表格邊框處理
              let borderCls = '';
              if (index === 0) borderCls += ' top';
              if (index === groups.length - 1) borderCls += ' bottom';
              return (
                <div className="row" key={`ins-${index}`}>
                  <div className={`title col left ${borderCls}`}>
                    {key}
                  </div>
                  <div className={`col right ${borderCls}`}>
                    {item.data ? renderTags(index, item.data[key]) : ''}
                  </div>
                </div>
              );
            })}
          </div>
        </li>
      );
    }
  };

  /**
   * @description 表格內險種方案呈現 (2025/06/27)
   * @param insIdx 險種
   * @param plans 方案
   */
  const renderTags = (insIdx: number, plans: string[]): JSX.Element => {
    return (
      <>
        {plans.map((it, index) => (
          <div className="tag" key={`insplan-${insIdx}-plan-${index}`}>
            {`${it}${index === plans.length - 1 ? '' : '、'}`}
          </div>
        ))}
      </>
    );
  };

  /**
   * @description 處理符合抽獎資格之投保條件
   */
  const renderInsureCondition = () => {
    const cond: ConditionItem | undefined = gameDetail?.CONDITION.find(it => it.COND_CLASS === 'INSURE');
    if (!cond) return null;
    // 組合投保條件元素
    const insureCondList: JSX.Element = (
      <ol className="list">
        {/* <li>險種/方案：{cond.INSPLAN_NOTE}</li> */}
        {renderInsPlans(cond.INSPLAN_NOTE)}
        <li>投保來源：{cond.SOURCE_NOTE}</li>
        <li>投保行為：{cond.BC_TYPE_NOTE}</li>
        <li>保費門檻：{cond.FEE_NOTE}</li>
        <li>保單寄送方式：{cond.POLICY_DELIVERY_NOTE}</li>
        <li>活動代碼/推薦員編：{cond.CECODE_NOTE}</li>
        <li>付款方式：{cond.PAY_BY_NOTE}</li>
      </ol>
    );
    // 若無 ${n} 關鍵字，則使用整串文字
    const isMatched = cond.COND_CLASS_DESC.match(/\$\{n\}/);
    if (!isMatched) {
      return (
        <li>
          投保：{cond.COND_CLASS_DESC}
          {insureCondList}
        </li>
      );
    }
    // 替換次數標記為抽講次數，並改為紅字
    const snippets = cond.COND_CLASS_DESC.split(/\$\{n\}/);
    return (
      <li>
        投保：{snippets[0]}<span className="emphsis">{cond.COND_CLASS_DCNT}</span>{snippets[1]}
        {insureCondList}
      </li>
    );
  };

  /**
   * @description 處理指定元素收合效果的切換
   * @param elemId 元素 id
   */
  const handleSlideToggle = (elemId: string) => {
    switch (elemId) {
      case 'desc':
        setDescCollapsed(prevState => !prevState);
        break;
      case 'condition':
        setConditionCollapsed(prevState => !prevState);
        break;
      default:
        break;
    }
    $(`#${elemId}`).slideToggle();
  };

  /**
   * @description 處理列表收合鈕 onClick 執行的事件
   */
  const handleListClick = () => {
    if (gameList.length === 0 || gameDetail === null) return;
    setListCollapsed(prevState => !prevState);
    $('#gamelist').slideToggle();
  };

  /**
   * @description 包含 html 結構之活動狀態文字
   * @param msg 活動狀態文字範本
   */
  const displayMsg = (gameSN: number, msg: string, isMobile: boolean) => {
    if (msg.includes('#')) {
      // 處理可抽獎文字範本
      const domElem: any[] = [];
      const spinnets = msg.split('#');
      domElem.push(spinnets[0]);
      domElem.push(<span key={`msg-${isMobile ? 'mobile' : 'pc'}-${gameSN}`} className="emphsis">&nbsp;{spinnets[1]}&nbsp;</span>);
      domElem.push(spinnets[2]);
      return domElem;
    }
    return msg;
  };

  /**
   * @description 拉霸機旋轉停止，則更新活動列表所選項目與明細
   * @param gameID 抽獎活動 ID
   */
  const handleRollingEnd = async (gameID: string) => {
    // 重查抽獎活動列表並取得對應項目
    let itemUpdated: ListItem | undefined;
    const argsList: GameQueryReq = {
      QUERY_TYPE: 'list'
    };
    const respList = await gameService.gameQuery(argsList);
    if (respList && respList.LIST) {
      itemUpdated = respList.LIST?.find(it => it.GAME_ID === gameID);
      if (itemUpdated) {
        const listUpdated: ListItem[] = [];
        _.cloneDeep(gameList).forEach(it => {
          if (itemUpdated && it.GAME_ID === gameID) {
            listUpdated.push(itemUpdated);
            return;
          }
          listUpdated.push(it);
        });
        setGameList(listUpdated);
      }
    }
    // 重查抽獎活動明細
    const argsDetail: GameQueryReq = {
      QUERY_TYPE: 'detail',
      GAME_ID: gameID
    };
    const respDetail: GameQueryResp | undefined = await gameService.gameQuery(argsDetail);
    if (itemUpdated && respDetail && respDetail.DATA) {
      setGameItem(itemUpdated);
      setGameDetail(respDetail.DATA);
      setDrawCount(itemUpdated.DRAW_CNT.toString());
      // 說明：維持收合狀態，故不設定
    }
  };

  /**
   * @description 緩存當前活動最後一次的抽獎結果
   */
  const saveLastResult = (gameSN: number, drawResult: GameDodrawResp, prizeItem: PrizeItem) => {
    setLastResult({
      SN: gameSN,
      result: drawResult,
      prize: prizeItem
    });
  };

  /**
   * @description 處理「我知道了」按鈕 onClick 執行的事件
   */
  const handleIKnowClick = () => {
    setLastResult(null);
    const campaignContent = document.querySelector('#slot-prize-content');
    if (campaignContent) {
      campaignContent.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };

  /**
   * @description 活動說明
   * @param briefItem 項目陣列
   */
  const renderBriefDesc = (briefItem: BriefItem[]) => {
    if (briefItem.length === 0) return null;
    const elem: JSX.Element[] = [];
    briefItem.forEach((it, index) => {
      if (index === briefItem.length - 1) {
        elem.push(<p key={`brief-${index}`}>{it.CODE_VALUE}</p>);
        return;
      }
      elem.push(<p key={`brief-${index}`}>{it.CODE_VALUE}</p>);
      // elem.push(<br />);
    });
    return elem;
  };

  return (
    <div className="page">
      {/* 抽獎活動列表 */}
      <section className="section list">
        <div className="campaignList">
          <div className="container">
            <div className="accordion">
              <div className={'button' + (gameDetail === null || gameList.length === 0 ? ' forbidden' : '')} aria-expanded={!listCollapsed} onClick={handleListClick}>
                抽獎活動列表
                <div className="icon">
                  <img className="caret" src={require('assets/images/caret-down.png')} alt="button" />
                </div>
                <span className="desc">登入會員即可瀏覽您目前的【可抽獎活動】</span>
              </div>
              <div id="gamelist" className="body">
                <div className="bg">
                  <img className="img" src={require('assets/images/look.png')} alt="background" />
                </div>
                <div className="content">
                  {/* top bar */}
                  <div className="topbar">
                    {statusList.map((status, index) => (
                      <button
                        type="button"
                        key={`status-${index}`}
                        className={'button' + (status.value === activeStatus.value ? ' active' : '')}
                        title={status.text}
                        onClick={() => handleStatusClick(status)}
                      >
                        {status.text}
                      </button>
                    ))}
                  </div>
                  <div className="content">
                    {/* PC 版抽獎活動 - 列表 */}
                    <Page
                      items={gameList.filter(it => it.STATUS_MSG.includes(activeStatus.keyword)).slice(pageIndex * PAGE_SIZE, (pageIndex * PAGE_SIZE) + PAGE_SIZE)}
                      totalCount={gameList.filter(it => it.STATUS_MSG.includes(activeStatus.keyword)).length}
                      pageSize={PAGE_SIZE}
                      pageIndex={pageIndex}
                      onItemClick={(item) => handleGameClick(item)}
                      onPageChange={(index) => setPageIndex(index)}
                      displayMsg={(gameSN, msg, isMobile) => displayMsg(gameSN, msg, isMobile)}
                    />
                    {/* 平版、手機版抽獎活動 - 列表 */}
                    <Slider
                      name="game"
                      items={gameList.filter(it => it.STATUS_MSG.includes(activeStatus.keyword))}
                      onItemClick={(item) => handleGameClick(item)}
                      displayMsg={(gameSN, msg, isMobile) => displayMsg(gameSN, msg, isMobile)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* 抽獎活動 - 明細 */}
      {gameDetail && (
        <>
          {/* 活動資料 */}
          <section id="slot-prize-content" className="section detail">
            <div className="campaignContent">
              <div className="bg">
                <img
                  className="img mobile"
                  src={require('assets/images/bg-mobile.png')}
                  alt="background"
                />
                <img
                  className="img pc"
                  src={require('assets/images/bg-pc.png')}
                  alt="background"
                />
              </div>
              <div className="content">
                <h1 className="heading">抽獎活動</h1>

                <div className="card">
                  <div className="poster">
                    <BgImage className="img" keepRatio imageUrl={commonService.convertImageUrl(gameDetail.IMAGE_NAME)} />
                  </div>
                  <div className="body">
                    {/* 活動名稱 */}
                    <div className="entry name">
                      <span className="title">活動名稱：</span>
                      <span className="text">{gameDetail.TITLE}</span>
                    </div>
                    {/* 活動時間 */}
                    <div className="entry time">
                      <span className="title">活動時間：</span>
                      <span className="text">{`${gameDetail.START_DATE}-${gameDetail.END_DATE}`}</span>
                    </div>
                    {/* 暫停需顯示「因故停止」與理由 */}
                    {gameDetail.STATUS === 'H' ? (
                      <div className="entry">
                        <span className="title">因故停止：</span>
                        <span className="text emphsis">{gameDetail.ONHOLD_MSG}</span>
                      </div>
                    ) : null}
                    {/* 可抽獎次數 */}
                    <div className="entry">
                      <span className="title">可抽獎次數：</span>
                      <span className="text">
                        <span className="emphsis">{drawCount}&nbsp;</span>次
                      </span>
                    </div>
                    {/* 說明 */}
                    <div className="description">
                      {/* <p className="emphsis">
                        {gameDetail.GAME_DESC}
                      </p> */}
                      <p className="emphsis">
                        {commonService.htmlParser(gameDetail.GAME_DESC)}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* 若無獎項，則不顯示獎項表格與拉霸機 */}
          {gameDetail.PRIZE.length > 0 && (
            <>
              {/* 活動獎項 */}
              <section className="section prize">
                <div className="prizeTable">
                  <div className="bg">
                    <img className="img" src={require('assets/images/earth.png')} alt="background" />
                  </div>
                  <div className="container">
                    <h1 className="title">活動獎項</h1>

                    <div className="content">
                      <table className="table">
                        <thead>
                          <tr className="tr">
                            <th className="th name">獎品</th>
                            <th className="th quantity">份數</th>
                          </tr>
                        </thead>
                        <tbody>
                          {gameDetail.PRIZE.map((it, index) => (
                            <tr className="tr" key={`${index}-${it.SN}`}>
                              <td className="td name">
                                {it.ITEM_NAME}
                              </td>
                              <td className="td quantity">
                                {it.ITEM_QTY}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div id="slot-prize-machine" />
                </div>
              </section>
              {/* 拉霸機: DRAW_STATUS 為 'D' 則顯示 */}
              {gameItem && (gameItem.DRAW_STATUS === DrawStatus.D || (lastResult?.SN === gameItem.SN)) && (
                <>
                  <section className="section slot">
                    <SlotMachine
                      gameSN={gameDetail.SN}
                      gameID={gameDetail.GAME_ID}
                      prizes={gameDetail.PRIZE}
                      drawStatus={gameItem.DRAW_STATUS}
                      drawCount={drawCount}
                      blnTitle={gameDetail.BLN_TITLE ?? ''}
                      blnDesc={gameDetail.BLN_DESC ?? ''}
                      blnImage={gameDetail.BLN_IMAGE ?? ''}
                      drawResult={lastResult}
                      saveDrawResult={saveLastResult}
                      onRollingEnd={handleRollingEnd}
                      onIKnow={handleIKnowClick}
                    />
                  </section>
                </>
              )}

            </>
          )}
          {/* 活動說明與資格 */}
          <section className="section introduction">
            <div className="campaignIntorduction">
              <div className="container">
                <div className="accordion">
                  <div className="accordionHeader button" aria-expanded={!descCollapsed} onClick={() => handleSlideToggle('desc')}>
                    活動說明
                    <div className="icon">
                      <img className="caret" src={require('assets/images/caret-down.png')} alt="button" />
                    </div>
                  </div>
                  <div id="desc" className="accordionBody body">
                    {/* <p>
                      {gameDetail.GAME_DESC}
                    </p> */}
                    {renderBriefDesc(gameDetail.GAME_BRIEF)}
                  </div>
                </div>
                <div className="accordion">
                  <div className="accordionHeader button" aria-expanded={!conditionCollapsed} onClick={() => handleSlideToggle('condition')}>
                    活動資格
                    <div className="icon">
                      <img className="caret" src={require('assets/images/caret-down.png')} alt="button" />
                    </div>
                  </div>
                  <div id="condition" className="accordionBody body">
                    <ul className="list">
                      {renderRegCondition()}
                      {renderInsureCondition()}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </>
      )}
    </div>
  );
};

export default Game;
